export default __webpack_public_path__ + "static/media/mobilePage.10229cdb.png";